// Browser-only invalidation; team authorization and invitation status remain server-owned.
export const TEAM_CHANGE_EVENT = "signaltuner:team-change";

export function notifyTeamChanged() {
  window.dispatchEvent(new Event(TEAM_CHANGE_EVENT));
}
